export const mapDateArray = (dates: { date: string }[]) =>
  dates.map((d) => new Date(`${d.date}T12:00:00+00:00`));

export const convertTimeToEst = (avTime: any) => {
  if (!avTime) return;

  let date = new Date(avTime);
  let convertTime = date.toLocaleString("en-US", {
    timeZone: "America/New_York",
  });
  // Extract time part and remove the leading comma
  let timePart = convertTime.slice(10, -6).trim();
  if (timePart.startsWith(',')) {
    timePart = timePart.substring(1).trim();
  }
  return `${timePart} ${convertTime.slice(-2)}`;
};
